class ConfirmationService {
  constructor() {
    this.handlers = new Map();
  }

  register(id, onConfirm, onCancel = null) {
    this.handlers.set(id, { onConfirm, onCancel });
    return id;
  }

  execute(id) {
    const handler = this.handlers.get(id);
    if (handler && handler.onConfirm) {
      return handler.onConfirm();
    }
    return Promise.resolve();
  }

  cancel(id) {
    const handler = this.handlers.get(id);
    if (handler && handler.onCancel) {
      handler.onCancel();
    }
    this.handlers.delete(id);
  }

  cleanup(id) {
    this.handlers.delete(id);
  }
}

export const confirmationService = new ConfirmationService();